<template>
  <div>
    <base-header v-if="0" class="pb-6  bg-gradient-info">
    
    <div style="min-height:30px;"></div>
 
      
      
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
     <div class="row justify-content-center">
      	  <div class="col-lg-8 card-wrapper" style="padding-left:10px;padding-right:10px;">
      	    <div style="min-height:140px;"></div>
      		<!-- Form controls -->
            <div class="card">
              <!-- Card header -->
              <div class="card-header bg-gradient-default">
              	<h2 class="heading mb-0 text-white">Update Details Of Company's Key Contact Person</h2>  		
              </div>
              <!-- Card body -->
              <div class="card-body">
                		
               <validation-observer v-slot="{handleSubmit}" ref="formValidator">
				   <form class="needs-validation" ref="contact_person_form"
          						@submit.prevent="handleSubmit(editContactPersonForm)">
                
                	<div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input prepend-icon="fas fa-user" label="First Name"   :rules="{required: true}" name="first name" v-model="model.first_name"/>
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input label="Last Name"  v-model="model.last_name"/>
						</div>
					</div>
					<!-- end row -->
					
					
					<div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		<base-input  prepend-icon="fas fa-phone" label="Contact Number" :rules="{required: true}" name="contact number"  v-model="model.contact_number"/>
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					 	 <base-input  prepend-icon="fas fa-envelope" label="Email Address" :rules="{required: true, email:true}" name="email"  v-model="model.email"/>
					 	</div>
					 	
					 </div><!-- end row -->
					 
					 <div class="row">
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		 
					  		 <base-input label="Position In The Company"
					  				 :rules="{required: true}"
							  			 name="position" 
					  		 >
							  <el-select v-model="model.position" filterable
							  			 
										 placeholder="Select from the following">
								<el-option v-for="option in selects.positions"
										   :key="option.label"
										   :label="option.label"
										   :value="option.value">
								</el-option>
							  </el-select>
							</base-input>
					 	</div>
					 	 <div class="col-xl-6" style="margin-top:20px;"> 
					  		
					 	</div>
					  </div> <!-- end row -->
                  
                  	 <div style="min-height:50px;"></div>
                  	 <base-button block type="primary" native-type="submit">Update</base-button>
                </form>
			   </validation-observer>


               
             
              </div>
             
            </div>
     
    

       	 </div>
      </div>
      <!-- End row-->

      <!--start new row-->
     




    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  import { Select, Option } from 'element-ui';
 
  export default {
    components: {
  		 [Select.name]: Select,
     	 [Option.name]: Option,
    },
    data() {
      return {
     	 model:{
     	 	first_name:'',
     	 	last_name:'',
     	 	contact_number:'',
     	 	email:'',
     	 	position:'d',
     	 
     	 },
     	 selects: {
			 positions: [
				{value: 'd', label: 'Director'},
				{value: 's', label: 'Shareholder'},
				{value: 'ds', label: 'Director & Shareholder'},
				{value: 'c', label: 'Contact Person / Agent'},
			   ],
		 },
		
      };
    },
    methods: {
      editContactPersonForm(){
      		const client_info = JSON.parse(TokenService.getUserInfo());
      		this.model.eid = client_info.entity_id;
      		
      		
      		swal.showLoading();
		  	let uri = this.$base_url+'/api/v1/c/edit_contact_person';
			 ApiService.post(uri, this.model).then(response => {
				swal.close();
				this.$router.push( '/ec_dashboard');
  
			}) 
      	
      },
    
    },
    mounted() {
    	 swal.showLoading();
    	const client_info = JSON.parse(TokenService.getUserInfo());
    	
    	let uri = this.$base_url+'/api/v1/c/get_contact_person/'+ client_info.entity_id;
        ApiService.get(uri).then(response => {
        	if(response.data.contact_person){
          		this.model = response.data.contact_person;
          	}
          	 swal.close();
      	});
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














